import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import React, { StrictMode, useMemo, useState } from "react";
import { createRoot } from "react-dom/client";
import "./style.css";

const gridDiv = document.querySelector("#myGrid");

const rowSelection = {
  mode: "multiRow",
  headerCheckbox: false,
};

const AgGrid = ({ RowData, ColumnDefs, gridOptions }) => {
  const defaultColDef = useMemo(() => {
    return {
      filter: "agTextColumnFilter",
      floatingFilter: true,
    };
  }, []);

  return (
    <div className={"ag-theme-quartz"} style={{ height: 428 }}>
      <AgGridReact
        rowData={RowData}
        columnDefs={ColumnDefs}
        defaultColDef={defaultColDef}
        rowSelection={rowSelection}
        gridOptions={gridOptions}
        pagination={true}
        paginationPageSize={10}
        paginationPageSizeSelector={[10, 25, 50]}
      />
    </div>
  );
};

export default AgGrid;
